import React, { useState, useEffect } from 'react';
import styles from '../static/styles/Notifications.module.css';

import firstNotificationBG from '../static/img/DailyTasks/iconCompletedBG.svg';
import { getUserNotifCount, getUserNotifs } from '../api/profile';

const Notifications = () => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.title = 'Notifications | Jazz Esl';

    const fetchNotifications = async () => {
      setLoading(true);
      try {
        const result = await getUserNotifs();

        if (result.success && result.EntryNotifications) {
          const formattedNotifications = result.EntryNotifications.map((notif, index) => ({
            id: index + 1,
            title: 'Notification',
            message: notif.message,
            isRead: notif.seen === 1,
          }));
          setNotifications(formattedNotifications);

          window.dispatchEvent(new Event('notificationsRead'));
        } else {
          setNotifications([]);
        }
      } catch (error) {
        setNotifications([]);
      } finally {
        setLoading(false);
      }
    };

    fetchNotifications();
  }, []);

  const unreadCount = notifications.filter(n => !n.isRead).length;

  return (
    <div className={styles.container}>
      <div className={styles.headerSection}>
        <h2 className={styles.heading}>Notifications</h2>
        {unreadCount > 0 && (
          <span className={styles.unreadBadge}>{unreadCount} new</span>
        )}
      </div>
      <p className={styles.subheading}>Stay updated with your latest activities</p>

      {loading && <div className={styles.loading}>Loading notifications...</div>}

      <div className={styles.notificationsContainer}>
        {notifications.length > 0 ? (
          notifications.map((notification, index) => (
            <div
              key={notification.id}
              className={styles.notificationCard}
              style={index === 0 ? { paddingTop: '35px', backgroundImage: `url(${firstNotificationBG})`, backgroundSize: 'cover', border: 'none', borderLeft: '4px solid white' } : {}}
            >
              <div className={styles.notificationContent}>
                <div className={styles.notificationText}>
                  <p className={styles.notificationTitle}>{notification.title}</p>
                  <p className={styles.notificationMessage}>{notification.message}</p>
                </div>
              </div>
            </div>
          ))
        ) : !loading && (
          <div className={styles.noNotifications}>No notifications available</div>
        )}
      </div>
    </div>
  );
};

export default Notifications;
